import { Box, Text, type HeadingProps, type TextProps } from "@chakra-ui/react"
import { Colors } from "../../theme/colors"
import { Heading2Caps } from "./Heading2Caps"

interface Heading2CapsSubTextInterface {
  headingText: string
  subText: string
  subTextStyles?: TextProps
  headingTextStyles?: HeadingProps
}
export const Heading2CapsSubText = ({ headingText, subText, subTextStyles, headingTextStyles }: Heading2CapsSubTextInterface): JSX.Element => (
  <Box>
    {
      // eslint-disable-next-line multiline-ternary
      headingText === "" ? (
        <></>
      ) : (
        <Heading2Caps
          props={{
            w: "100%",
            pb: "3",
            borderBottomWidth: "4px",
            px: "0",
            minHeight: "100px",
            alignItems: "center",
            display: "flex",
            justifyContent: "center",
            ...headingTextStyles
          }}
          text={headingText}
        />
      )
    }
    <Text variant={"Body1Regular"} color={Colors.SecondaryPrimary.c2} mt="10px" mb="18px" {...subTextStyles}>
      {subText}
    </Text>
  </Box>
)
